export default "__VITE_ASSET__DhsYnaPr__"